import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import GlobalFooter from './GlobalFooter';

function Pending() {
    const record = JSON.parse(localStorage.getItem("auth"))

    const location = useLocation();
    const { result } = location.state || {};
    const navigate = useNavigate()

    const redirect = result?.data?.redirectUrl
    const handleClick = () => {
        if (redirect && redirect.startsWith('http')) {
            // Redirect immediately on button click
            window.location.href = redirect;
        }
    };

    useEffect(() => {
        if (redirect && redirect.startsWith('http')) {
           
            const timer = setTimeout(() => {
                window.location.href = redirect;
            }, 3000);
            return () => clearTimeout(timer); // Cleanup the timer on component unmount
        }
    }, [redirect]);

    // const handleClose = ()=>{
    //     navigate('/pages/global-payment')
    // }

  return (
    <div className='global_layout'>
        
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' onClick={handleClick} style={{marginLeft:"auto"}}/>
            </div>

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/success.gif' alt='' />
                <p className='glob_title'>Successful!</p>
                <p className='glob_desc'>Payment has been successfully initiated.</p>
                {
                    redirect && redirect.startsWith('http') &&
                    <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Ok, got it</button>
                }
            </div>
        </div>
        {/* {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        } */}
    </div>
  )
}

export default Pending